import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { ThemeModel, ThemeService } from './api-services';

@Injectable({
  providedIn: 'root'
})
export class DocumentThemeService {
  constructor(@Inject(DOCUMENT) readonly document: Document,
    private readonly themeService: ThemeService) {
  }

  public apply(): void {
    this.themeService.get()
      .subscribe(theme => {
        if (!theme) {
          // TODO: Set default
          return;
        }

        const style = this.createThemeStyle(this.document, theme);

        this.document.head.appendChild(style);

        const link = this.createThemeLink(this.document, theme);

        this.document.head.appendChild(link);
      });
  }

  private createThemeStyle(document: Document, theme: ThemeModel): HTMLStyleElement {
    const element = document.createElement('style');
    element.innerHTML = `:root {
--font-family: "${theme.fontFamily}";
--accent-color-50: ${theme.accentPalette.color50};
--accent-color-100: ${theme.accentPalette.color100};
--accent-color-200: ${theme.accentPalette.color200};
--accent-color-300: ${theme.accentPalette.color300};
--accent-color-400: ${theme.accentPalette.color400};
--accent-color-500: ${theme.accentPalette.color500};
--accent-color-600: ${theme.accentPalette.color600};
--accent-color-700: ${theme.accentPalette.color700};
--accent-color-800: ${theme.accentPalette.color800};
--accent-color-900: ${theme.accentPalette.color900};
--accent-color-A100: ${theme.accentPalette.colorA100};
--accent-color-A200: ${theme.accentPalette.colorA200};
--accent-color-A400: ${theme.accentPalette.colorA400};
--accent-color-A700: ${theme.accentPalette.colorA700};
--accent-contrast-color-50: ${theme.accentContrastPalette.color50};
--accent-contrast-color-100: ${theme.accentContrastPalette.color100};
--accent-contrast-color-200: ${theme.accentContrastPalette.color200};
--accent-contrast-color-300: ${theme.accentContrastPalette.color300};
--accent-contrast-color-400: ${theme.accentContrastPalette.color400};
--accent-contrast-color-500: ${theme.accentContrastPalette.color500};
--accent-contrast-color-600: ${theme.accentContrastPalette.color600};
--accent-contrast-color-700: ${theme.accentContrastPalette.color700};
--accent-contrast-color-800: ${theme.accentContrastPalette.color800};
--accent-contrast-color-900: ${theme.accentContrastPalette.color900};
--accent-contrast-color-A100: ${theme.accentContrastPalette.colorA100};
--accent-contrast-color-A200: ${theme.accentContrastPalette.colorA200};
--accent-contrast-color-A400: ${theme.accentContrastPalette.colorA400};
--accent-contrast-color-A700: ${theme.accentContrastPalette.colorA700};
}`;

    return element;
  }

  private createThemeLink(document: Document, theme: ThemeModel): HTMLStyleElement {
    const fontFamily = theme.fontFamily
      .replace(' ', '+');

    const element = document.createElement('link');
    element.href = `https://fonts.googleapis.com/css?family=${fontFamily}`
    element.rel = 'stylesheet';

    return element;
  }
}
